export function isEqualJson(a, b) {
    return a === b || JSON.stringify(a) === JSON.stringify(b);
}

export function parseJson(json, defaultValue) {
    let result;

    try {
        result = JSON.parse(json);
    } catch (e) {
        result = defaultValue;
    }

    return result;
}
